import styled from 'styled-components'
import { AutoCompleteUnstyled } from './unstyled'

export const AutoComplete = styled(AutoCompleteUnstyled)`
  position: relative;
  height: 40px;

  .select-field {
    background: ${props => props.theme.colors.white} !important;
    border: 1px solid ${props => props.theme.colors.iron} !important;
    height: 40px !important;
    width: inherit !important;

    div {
      max-height: 40px !important;
    }

    hr {
      display: none !important;
    }

    button {
      height: 40px !important;
    }

    div:nth-child(2) {
      div:nth-child(2) {
        height: 40px !important;
        line-height: 40px !important;
        top: 0 !important;
        font-size: ${props =>
          props.theme.fontSizes.materialUI.selectField} !important;
        padding-left: 15px !important;
        padding-right: 35px !important;
        color: ${props => props.theme.colors.secondary} !important;
        font-weight: initial !important;
      }
    }
  }

  svg {
    position: absolute;
    width: 13px;
    height: 100%;
    right: 40px;
    z-index: ${props => props.theme.zIndexes.mainContentWrapper.first};
    transform: rotate(90deg);
    fill: ${props => props.theme.colors.secondary};
    pointer-events: none;
  }
`
